import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import AddIcon from "@mui/icons-material/Add";
import { css, StyleSheet } from "aphrodite";
import { ReactNode } from "react";
import { useDrop } from "react-dnd";
import { DraggableFormCell, DraggableFormCellItem } from "./DraggableFormCell";
import { DraggableItemTypes } from "./DraggableItemTypes";
import * as auto_pi from "@crochik/auto-pi";
import { Paper } from "@mui/material";
import { FieldTypeIcon } from "../../FieldTypeIcon";

interface Props {
    fields: auto_pi.Field[];
    form: auto_pi.Form;
    onAdd?(type: auto_pi.FieldTEnum): void;
    onDrop(item: DraggableFormCellItem): void;
    onProperties?: (field: auto_pi.Field) => void;
    onRender?(field: auto_pi.Field): ReactNode;
    width: number;
}

export function HiddenFieldSidebar(props: Props) {
    const { fields, form, onDrop, onAdd, width, onProperties, onRender } = props;

    const [{ isOver }, drop] = useDrop<DraggableFormCellItem, any, any>(() => ({
        accept: DraggableItemTypes.FIELD,
        drop: onDrop,
        canDrop: (item: DraggableFormCellItem) => !item.hidden,
        collect: (monitor) => ({
            isOver: !!monitor.isOver() && !!monitor.canDrop(),
        }),
    }));

    const onAddField = (type: auto_pi.FieldTEnum) => () => onAdd?.(type);

    return (
        <div className={css(styles.container, isOver && styles.active)} style={{ width }} ref={drop}>
            <div className={css(styles.title)}>
                <div>{"Hidden Fields"}</div>
                <VisibilityOffIcon />
            </div>
            <div style={{ height: 'calc(50% - 50px)', overflow: "auto" }}>
                {fields.map((field, index) => {
                    return <DraggableFormCell key={`form-cell-${index}`} field={field} form={form} index={index} row={index} hidden={true} onShowInfo={onProperties} onRender={onRender} />;
                })}
            </div>
            <div className={css(styles.title)}>
                <div>{"Add Field"}</div>
                {/* <AddIcon /> */}
            </div>
            <div style={{ height: 'calc(50% - 50px)',  overflow: "auto" }}>
                {
                    Object.keys(auto_pi.FieldTEnum).map(x => (
                        <Paper style={{
                            margin: 8,
                            width: "calc(100% - 16px)",
                            // backgroundColor: ro ? "white" : "#eeeeee",
                            padding: 4,
                            alignItems: "center",
                            display: "flex",
                            flexDirection: "row",
                            cursor: "pointer"
                            // border: ro ? "2px dotted lightgray" : undefined
                        }} elevation={2} onClick={onAddField(x as auto_pi.FieldTEnum)}>
                            <div
                                style={{
                                    padding: 6, display: "flex", flexDirection: "row", width: "100%"
                                }}
                            >
                                <div style={{ width: 30, display: "flex", alignItems: "center", justifyContent: "center" }}>
                                    <FieldTypeIcon type={x as auto_pi.FieldTEnum} /></div>
                                <div>
                                    {x.substring(0, x.length-5)}
                                </div>
                            </div>
                        </Paper>
                    ))
                }
            </div>
        </div >
    );
}

const styles = StyleSheet.create({
    container: {
        backgroundColor: "#fff",
        height: "100%",
        padding: 8,
        borderWidth: 2,
        borderStyle: "dashed",
        borderColor: "transparent",
        overflowY: "auto",
    },
    active: {
        borderColor: "#42A5F5",
    },
    title: {
        padding: 8,
        fontSize: 18,
        display: "flex",
        fontWeight: "bold",
        justifyContent: "space-between",
    },
});
